import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioNo from 'assets/sounds/no/3 01 Tulleord Intro.mp3';
import audioNn from 'assets/sounds/nn/3 01 Tulleord Intro.mp3';
import audioNoNorming from 'assets/sounds/adult/tulleordtestenSounds/no/Tulleord-instruksjoner-Dysmate-A.mp3';
import audioNnNorming from 'assets/sounds/adult/tulleordtestenSounds/nn/Tulleord-instruksjoner-Dysmate-A.mp3';

const languageObj = {
	no: audioNo,
	nn: audioNn,
};
const normingLanguageObj = {
	no: audioNoNorming,
	nn: audioNnNorming,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		const isNorming = this.props.isNorming ? 1 : 0;
		this.audio =
			isNorming === 1
				? normingLanguageObj[strings.getLanguage()]
				: languageObj[strings.getLanguage()];
	}

	render() {
		const {onNextStep, isNorming} = this.props;
		return (
			<div>
				<p>
					<AudioPlayer
						autoplay
						inline
						src={this.audio}
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
					/>
					{isNorming
						? strings.tulleordtestenNormingIntro
						: strings.tulleordtestenIntro}
				</p>
				<p>
					{isNorming
						? strings.tulleordtestenNormingPractice
						: strings.tulleordtestenPractice}
				</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
